export const EMPTY_STRING = '';
export const FORMAT_DATE_DDMMYYYY = 'DD.MM.YYYY';
export const FORMAT_HHmm = 'HH:mm';
export const FORMAT_WITH_TIME = 'YYYY-MM-DDTHH:mm:ss';
export const FORMAT_DATE_FOR_LOG = 'DD-MM-yyyy HH:mm:ss';

export const USER_TYPES = {
  client: 'client',
  mapsClient: 'maps-client',
  agent: 'regional-mimic-client',
  regional: 'regional',
  logistician: 'logistician',
  none: 'none',
} as const;
